export default __webpack_public_path__ + "static/media/BP04 copy.438b4aa1.jpg";